import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#F4F2F2]">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#F4F2F2]/80 backdrop-blur-sm border-b border-[#CAC7C7]">
        <nav className="w-full px-8 py-4 flex justify-between items-center max-w-4xl mx-auto">
          <Link
            to="/"
            className="text-2xl font-serif text-[#2E2A23] tracking-tight hover:text-[#E94E1B] transition-colors"
          >
            Newsletter
          </Link>
          <Link
            to="/login"
            className="flex items-center gap-2 text-[#888185] hover:text-[#E94E1B] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm font-medium">Voltar</span>
          </Link>
        </nav>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-8 py-12">
        <h1 className="font-serif text-4xl md:text-5xl text-[#2E2A23] mb-8">
          Política de Privacidade
        </h1>
        <p className="text-[#888185] text-sm mb-12">Última atualização: Janeiro de 2026</p>

        <div className="prose prose-lg max-w-none text-[#888185]">
          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">1. Introdução</h2>
            <p className="leading-relaxed">
              O Newsletter está comprometido em proteger sua privacidade. Esta Política de
              Privacidade explica como coletamos, usamos, divulgamos e protegemos suas informações
              quando você usa nosso serviço.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">
              2. Informações que Coletamos
            </h2>

            <h3 className="font-serif text-xl text-[#2E2A23] mb-3 mt-6">
              2.1 Informações de Conta
            </h3>
            <p className="leading-relaxed">Quando você cria uma conta, coletamos:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Endereço de email</li>
              <li>Nome (opcional)</li>
              <li>Preferências de perfil (cargo, indústria, interesses)</li>
            </ul>

            <h3 className="font-serif text-xl text-[#2E2A23] mb-3 mt-6">2.2 Dados de Uso</h3>
            <p className="leading-relaxed">
              Coletamos automaticamente informações sobre como você interage com o serviço:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Conteúdos visualizados, salvos e curtidos</li>
              <li>Preferências de temas e categorias</li>
              <li>Autores e fontes silenciados</li>
              <li>Padrões de navegação e tempo de leitura</li>
            </ul>

            <h3 className="font-serif text-xl text-[#2E2A23] mb-3 mt-6">2.3 Dados Técnicos</h3>
            <p className="leading-relaxed">Podemos coletar informações técnicas como:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Tipo de dispositivo e navegador</li>
              <li>Sistema operacional</li>
              <li>Endereço IP (anonimizado)</li>
              <li>Informações de cookies</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">
              3. Como Usamos suas Informações
            </h2>
            <p className="leading-relaxed">Usamos as informações coletadas para:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Personalizar seu feed de conteúdo</li>
              <li>Melhorar nossos algoritmos de recomendação</li>
              <li>Manter e melhorar o serviço</li>
              <li>Comunicar atualizações importantes sobre o serviço</li>
              <li>Detectar e prevenir fraudes ou uso indevido</li>
              <li>Cumprir obrigações legais</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">
              4. Compartilhamento de Dados
            </h2>
            <p className="leading-relaxed">
              Não vendemos suas informações pessoais. Podemos compartilhar dados apenas:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>
                Com provedores de serviço que nos ajudam a operar o Newsletter (hospedagem, análise)
              </li>
              <li>Quando exigido por lei ou ordem judicial</li>
              <li>Para proteger nossos direitos, privacidade, segurança ou propriedade</li>
              <li>Em caso de fusão, aquisição ou venda de ativos (com notificação prévia)</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">
              5. Armazenamento e Segurança
            </h2>
            <p className="leading-relaxed">
              Seus dados são armazenados em servidores seguros com criptografia em trânsito e em
              repouso. Implementamos medidas de segurança técnicas e organizacionais para proteger
              suas informações contra acesso não autorizado, alteração ou destruição.
            </p>
            <p className="leading-relaxed mt-4">
              Mantemos seus dados pelo tempo necessário para fornecer o serviço ou conforme exigido
              por lei. Você pode solicitar a exclusão de sua conta a qualquer momento.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">6. Seus Direitos</h2>
            <p className="leading-relaxed">
              De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>
                <strong>Acesso:</strong> Solicitar uma cópia dos dados que temos sobre você
              </li>
              <li>
                <strong>Correção:</strong> Corrigir dados incompletos ou imprecisos
              </li>
              <li>
                <strong>Exclusão:</strong> Solicitar a exclusão de seus dados pessoais
              </li>
              <li>
                <strong>Portabilidade:</strong> Receber seus dados em formato estruturado
              </li>
              <li>
                <strong>Revogação:</strong> Retirar consentimento para processamento de dados
              </li>
              <li>
                <strong>Oposição:</strong> Opor-se ao processamento de seus dados em certas
                circunstâncias
              </li>
            </ul>
            <p className="leading-relaxed mt-4">
              Para exercer qualquer desses direitos, entre em contato pelo email:{' '}
              <a
                href="mailto:privacidade@banquinha.com.br"
                className="text-[#E94E1B] hover:underline"
              >
                privacidade@banquinha.com.br
              </a>
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">7. Cookies</h2>
            <p className="leading-relaxed">
              Usamos cookies essenciais para o funcionamento do serviço, incluindo:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Cookies de autenticação para manter sua sessão</li>
              <li>Cookies de preferências para lembrar suas configurações</li>
            </ul>
            <p className="leading-relaxed mt-4">
              Também utilizamos cookies de análise (Microsoft Clarity) para entender como os
              usuários interagem com a plataforma e melhorar a experiência do serviço. Esses cookies
              são ativados somente após o seu consentimento explícito, exibido ao acessar o site
              pela primeira vez. Não usamos cookies de publicidade de terceiros.
            </p>
            <p className="leading-relaxed mt-4">
              Você pode gerenciar suas preferências de cookies a qualquer momento limpando os dados
              do site nas configurações do seu navegador.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">8. Menores de Idade</h2>
            <p className="leading-relaxed">
              O Newsletter não é destinado a menores de 18 anos. Não coletamos intencionalmente
              informações de menores. Se você acredita que coletamos dados de um menor, entre em
              contato conosco imediatamente.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">
              9. Alterações nesta Política
            </h2>
            <p className="leading-relaxed">
              Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre
              alterações significativas por email ou aviso no aplicativo. Recomendamos revisar esta
              política regularmente.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-serif text-2xl text-[#2E2A23] mb-4">10. Contato</h2>
            <p className="leading-relaxed">
              Para dúvidas sobre esta Política de Privacidade ou sobre como tratamos seus dados:
            </p>
            <ul className="list-none mt-4 space-y-2">
              <li>
                <strong>Email:</strong>{' '}
                <a
                  href="mailto:privacidade@banquinha.com.br"
                  className="text-[#E94E1B] hover:underline"
                >
                  privacidade@banquinha.com.br
                </a>
              </li>
              <li>
                <strong>Encarregado de Proteção de Dados (DPO):</strong>{' '}
                <a href="mailto:dpo@banquinha.com.br" className="text-[#E94E1B] hover:underline">
                  dpo@banquinha.com.br
                </a>
              </li>
            </ul>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 py-12 border-t border-[#CAC7C7]">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="font-serif text-xl text-[#2E2A23]">Newsletter</div>
            <div className="flex gap-6 text-sm text-[#888185]">
              <Link to="/terms" className="hover:text-[#E94E1B] transition-colors">
                Termos de Uso
              </Link>
              <Link to="/privacy" className="hover:text-[#E94E1B] transition-colors">
                Política de Privacidade
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
